export const EXTERNAL_PROVIDERS = {
    INTERCASH: 9,
    STRADE_CARTE: 23,
} as const;

export const CARD_TYPES = {
    VIRTUAL: 1,
    PHYSICALREQUESTED: 2,
    CONVERTING: 3,
    PHYSICAL: 4,
} as const;

export const CARD_TYPE_DETAILS = {
    1: { label: 'Virtual', color: '#2046a1', bgColor: '#e3f2fd', icon: '💳' },
    2: { label: 'Physical Requested', color: '#ff8f00', bgColor: '#fff3e0', icon: '📋' },
    3: { label: 'Converting', color: '#7b1fa2', bgColor: '#f3e5f5', icon: '🔄' },
    4: { label: 'Physical', color: '#388e3c', bgColor: '#e8f5e8', icon: '🏦' },
} as const;

export const CARD_STATUSES = {
    NEW: -1,
    ISSUED: 0,
    ACTIVATED: 1,
    HOLD: 2,
    SUSPEND: 3,
    NORMAL: 4,
    INACTIVE: 5,
    LOST: 6,
    STOLEN: 7,
    EXPIRED: 8,
    DENIED: 9,
    DELIVERY: 10,
} as const;

export const CARD_CURRENCIES = {
    1: 'USD',
    2: 'EUR',
} as const;

export const CARD_STATUS_DETAILS = {
    [-1]: { label: 'New', color: 'orange' },
    0: { label: 'Issued', color: 'blue' },
    1: { label: 'Activated', color: 'green' },
    2: { label: 'Hold', color: 'orange' },
    3: { label: 'Suspended', color: 'red' },
    4: { label: 'Normal', color: 'green' },
    5: { label: 'Inactive', color: 'gray' },
    6: { label: 'Lost', color: 'red' },
    7: { label: 'Stolen', color: 'red' },
    8: { label: 'Expired', color: 'gray' },
    9: { label: 'Denied', color: 'red' },
    10: { label: 'Delivery', color: 'blue' },
} as const;

export const CARD_LIMITS = {
    EUR: 1,
    USD: 4,
} as const;

export const PROVIDER_FEATURES = {
    [EXTERNAL_PROVIDERS.STRADE_CARTE]: {
        hasFullData: false,
        isPhysical: true,
        availableFields: ['cardNumber'],
    },
    [EXTERNAL_PROVIDERS.INTERCASH]: {
        hasFullData: true,
        isPhysical: false,
        availableFields: ['cardNumber', 'cvv', 'expireDate', 'balance', 'status', 'san'],
    },
} as const; 